import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Text from "@commons/Typography/Text";
import { useUser } from "@hooks/useUser";
import { useNavigate } from "react-router-dom";
import { paths } from "@/paths";

type ProfileMenuProps = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
};

export function HeaderProfileMenu({ anchorEl, onClose }: ProfileMenuProps) {
  const { signOut } = useUser();
  const navigate = useNavigate();
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MenuItem
        onClick={() => {
          onClose();
          navigate(paths.profile);
        }}
        className="w-24 sm:w-32"
      >
        <Text customVariant="gray">Perfil</Text>
      </MenuItem>
      <MenuItem onClick={signOut} className="hover:bg-red-50 w-24 sm:w-32">
        <Text customVariant="red">Sair</Text>
      </MenuItem>
    </Menu>
  );
}
